
import { Component, Output, EventEmitter, Input } from '@angular/core';
/**
 * componente di ricerca con autocompletamento che supporta chiamate a servizi remoti
 */
@Component({
    selector: 'autocomplete',
    templateUrl: './auto-complete.component.html',
    styleUrls: ['./auto-complete.component.scss'],
    standalone: false
})
export class AutoCompleteComponent {

    @Input() labelProperty: string;

    @Input() placeholder = 'Cerca';

    @Input() debounce = 1000;

    @Input() noResultMessage = 'report.autocomplete.notfound'//Da cambiare!

    @Input() minlength = 3;

    @Input() service: any;

    @Input() filter: any;

    @Input() searchCallback: Function;

    // tslint:disable-next-line:no-output-on-prefix
    @Output() public onSelect: EventEmitter<any>;

    // tslint:disable-next-line:no-output-on-prefix
    @Output() public onCancel: EventEmitter<any>;

    public search: string;

    public result: any[];
    private selected: any;
    private subscription;

    public noResult: boolean;
    ignoreNextChange = false;

    constructor() {
        this.onSelect = new EventEmitter<any>();
        this.onCancel = new EventEmitter<any>();
    }

    public change(event) {

        if (this.search === '' ) {
            this.onCancel.emit(undefined);
            this.search = undefined;
            this.result = undefined;
            this.unsubscribe();
            return;
        }

        if (this.ignoreNextChange) {
            this.ignoreNextChange = false;
            return;
        }
        if (!this.service) {
            console.log('don\'t know how to search because [service] is not defined...');
            return;
        }

        if (!this.searchCallback) {
            console.log('don\'t know how to search because [searchCallback] is not defined...');
            return;
        }

        if (this.search && this.search.length >= this.minlength) {
            this.result = [];
            this.noResult = false;
            this.subscription = this.searchCallback(this.service, this.search, this.filter).subscribe((result) => {
                if (!result || result.length === 0) {
                    this.noResult = true;
                } else {
                    this.result = result;
                }
            });
        } else {
            this.cancel(undefined);
        }
    }

    public isSearching() {
        return this.subscription && this.result.length === 0 && !this.noResult;
    }

    public isResultReady() {
        return this.result && this.result.length > 0 && !this.noResult;
    }

    public select(selected) {
        this.selected = selected;
        this.search = selected[this.labelProperty];
        this.result = [];
        this.noResult = false;
        this.ignoreNextChange = true;
        this.onSelect.emit(this.selected);
        this.unsubscribe();
    }

    public cancel(event) {
        this.selected = undefined;
        this.noResult = false;
        this.result = [];
        this.onCancel.emit(undefined);
        this.unsubscribe();
    }

    private unsubscribe() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }
}
